import React ,{ useContext, useState } from 'react';

import Modal from '../UI/Modal';
import CartItem from './CartItem';
import classes from './Cart.module.css';
import CartContext from '../../store/cart-context';
import Checkout from './Checkout';

const Cart = (props) => {

  const [isCheckout, setIsCheckout] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [diSubmit, setDidSubmit] = useState(false);

  const cartCtx = useContext(CartContext);

  const totalAmount = `$${cartCtx.totalAmount.toFixed(2)}`;
  const hasItems = cartCtx.items.length > 0;

  const cartItemRemoveHandler = (id) => {
    cartCtx.removeItem(id);
  };

  const cartItemAddHandler = (item) => {
    cartCtx.addItem({ ...item, amount: 1 });
  };

  const onSubmitOrderHandler = async (userData)=>{
    setIsSubmitting(true);
    await fetch('https://food-order-app-40271-default-rtdb.firebaseio.com/order.json', {
      method:'POST',
      body:JSON.stringify({
        user:userData,
        orderedItem:cartCtx.items
      })
    });
    setIsSubmitting(false);
    setDidSubmit(true);
    cartCtx.clearCart();
  };

  const cartItems = (
    <ul className={classes['cart-items']}>
      {cartCtx.items.map((item) => (
        <CartItem
          key={item.id}
          name={item.name}
          amount={item.amount}
          price={item.price}
          onRemove={cartItemRemoveHandler.bind(null, item.id)}
          onAdd={cartItemAddHandler.bind(null, item)}
        />
      ))}
    </ul>
  );

  const orderHandler=()=>{
    setIsCheckout(true);
  }

  const modalActions =  <div className={classes.actions}>
  <button className={classes['button--alt']} onClick={props.onClose}>
    Close
  </button>
  {hasItems && 
    <button className={classes.button} onClick={orderHandler}>
      Order
    </button>}
</div> ;

const cartModalContext = (
  <React.Fragment>
      {cartItems}
      <div className={classes.total}>
        <span>Total Amount</span>
        <span>{totalAmount}</span>
      </div>
      {isCheckout && <Checkout onConfirm={onSubmitOrderHandler} onCancel={props.onClose}/>}
      {!isCheckout && modalActions} 
  </React.Fragment>
);

const isSubmittingModalContent = <p>Sending Order Data !!!</p>;
const didSubmitModalContent = (
  <React.Fragment>
    <p>Oder Sent Successfully !!!</p>
    <div className={classes.actions}>
      <button className={classes.button} onClick={props.onClose}>
        Close
      </button>
    </div>
  </React.Fragment>
);


  return (
    <Modal onClose={props.onClose}>
      {!isSubmitting && !diSubmit && cartModalContext}
      {isSubmitting && isSubmittingModalContent}
      {!isSubmitting && diSubmit && didSubmitModalContent}
    </Modal>
  );
};

export default Cart;
